import { ChangeEvent, useEffect, useRef, useState } from "react"
import { observer } from "mobx-react-lite"
import { useStore } from "../../contexts/store"
import { useTranslation } from "react-i18next"
import { Box, Paper, TextField } from "@mui/material"
import { navigate } from "wouter/use-browser-location"
import { Op_editAnnotation } from "../../shared/src/types/Ops"
import { Interaction } from "../../shared/src/types/Interaction"
import SaveCancel from "./SaveCancel"
import BlockquoteBox from "./BlockquoteBox"
import MarkdownEnabledTextfield from './MarkdownEnabledTextfield'
import { markdownWhitelistMessages } from "./Message"
import PrettyMarkdownBox from "../PrettyMarkdownInput/PrettyMarkdownBox"
import PrettyMarkdownInput from "../PrettyMarkdownInput/PrettyMarkdownInput"


const Note = ({ backUrl, interaction, podId} : {backUrl: string, interaction: Interaction, podId: string}) => {
  const { t } = useTranslation()
  const { opStore, podStore, sessionStore } = useStore()
  const [shiftIsPressed, setShiftIsPressed] = useState(false)

  const [text, setText] = useState("")
  const textRef = useRef("")
  const interactionId = interaction.interactionId
  const textInput = interaction.label
  const session = sessionStore.session

  // keep last text input
  useEffect(() => {
    textRef.current = text
  }, [text])

  // on mount
  useEffect(() => {

    const submitChange = () => {
      if(podId && interactionId && session) {
        const opEditAnn:Op_editAnnotation = {
          op: 'editAnnotation',
          podId: podId,
          data: {
            userId: session.user.userId,
            userName: podStore.userPseudonym as string,
            usergroupId: podStore.getUsergroupByRole('Private').usergroupId,
            interactionId: interactionId,
            mods: {
              label: textRef.current
            }
          }
        }
        opStore.doOp(opEditAnn)
      }
    }

    // set interaction text
    if(textInput) {
      setText(textInput)
      textRef.current = textInput
    }
    else setText("")

    // on unmount: save last text input
    return () => {
      if ((textRef.current !== textInput) && (podStore.pod?.getInteraction(interactionId))) submitChange()
    }
  }, [textInput, interactionId, podStore.pod, opStore, podId, podStore, session])

  if (!session) return null



  const handleSave = () => {
    navigate(`${backUrl}`, {replace: true, state: {prevUrl: window.location.pathname}})
  }

  const handleCancel = () => {
    textRef.current = textInput
    navigate(`${backUrl}`, {replace: true, state: {prevUrl: window.location.pathname}})
  }

  function handleTextareaChange(e: ChangeEvent<HTMLInputElement>) {
    setText(e.target.value)
  }

  return (
    <Box sx={{display: "grid", overflow:'scroll', gridTemplateRows: "min-content min-content auto min-content",
        '.MuiInputBase-multiline fieldset': {
          border:'none !important'
        }
      }}>
      <BlockquoteBox interaction={interaction} />
      <Box sx={{
        padding: "20px 0 0 20px",
      }}>
        {t('Notes')}
      </Box>
      <Box style={{overflow:'hidden', backgroundColor: "#ffea77", marginLeft:'7px'}}>
        <MarkdownEnabledTextfield
          value={text}
          handleInputChange={handleTextareaChange}
          handleClose={()=>{}}
          minRows={3}
          disabled={false}
          submit={() => {}}
          style={{ height:'98%' }}
          whitelist={markdownWhitelistMessages}
          helperText={''}
          slotProps= {{
            markdown: {
              style: { border:'none' }
            }
          }}
          />
      </Box>
      <Box sx={{ display: "grid", alignSelf: "end", margin: "20px 10px" }}>
        <SaveCancel handleSave={handleSave} handleClose={handleCancel} />
      </Box>
    </Box>
  )
}

export default observer(Note)